import { useState } from 'react';
import type { SaleCancelResult } from '@kassa/shared';
import { api, ApiError } from '../api';
import { formatMoney } from '../format';

// Satışın ləğvi (KT-101): səbəb məcburi; kassir üçün menecer PİN-i. Ləğv sənədi (LƏĞ) qalığı, ödənişi və nisyəni geri qaytarır.
// Eyni pəncərədə təkrar «Ləğv et» eyni UUID ilə gedir — ikinci sənəd yaranmır.
export function CancelSale({ saleId, displayNo, onDone, onClose }: { saleId: string; displayNo: string; onDone: (r: SaleCancelResult) => void; onClose: () => void }) {
  const [id] = useState(() => crypto.randomUUID());
  const [reason, setReason] = useState('');
  const [pin, setPin] = useState('');
  const [needPin, setNeedPin] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit() {
    setBusy(true);
    setError(null);
    try {
      const r = await api.saleCancel(saleId, { id, reason: reason.trim(), pin: pin || null });
      onDone(r);
    } catch (err) {
      if (err instanceof ApiError && (err.code === 'cancel_pin' || err.code === 'pin_invalid')) setNeedPin(true);
      setError(err instanceof ApiError ? err.message : 'Ləğv alınmadı. Yenidən cəhd edin.');
    } finally {
      setPin('');
      setBusy(false);
    }
  }

  return (
    <div className="modal-overlay">
      <div className="modal-box card" role="dialog" aria-modal="true" aria-label={`${displayNo} — satışın ləğvi`}>
        <h2>Satışı ləğv et</h2>
        <p className="muted small">
          {displayNo}: mal anbara qayıdır, nağd kassadan qaytarılır, nisyə bağlanır. Kart ödənişini terminalda geri qaytarın.
        </p>
        <label className="field">
          <span>
            Səbəb <span className="req" aria-hidden="true">*</span>
          </span>
          <input value={reason} onChange={(e) => setReason(e.target.value)} maxLength={300} disabled={busy} autoFocus />
        </label>
        {needPin && (
          <label className="field">
            Menecer PİN-i
            <input type="password" inputMode="numeric" autoComplete="off" value={pin} onChange={(e) => setPin(e.target.value)} disabled={busy} />
          </label>
        )}
        {error && (
          <p className="bad" role="alert">
            {error}
          </p>
        )}
        <div className="form-actions">
          <button type="button" className="btn-small" onClick={onClose} disabled={busy}>
            Bağla
          </button>
          <button type="button" className="btn-danger" onClick={() => void submit()} disabled={busy || reason.trim().length < 3 || (needPin && pin.length < 4)}>
            {busy ? 'Ləğv edilir…' : 'Ləğv et'}
          </button>
        </div>
      </div>
    </div>
  );
}

export function cancelSummary(r: SaleCancelResult): string {
  const parts = [r.cash > 0 && `nağd ${formatMoney(r.cash)}`, r.card > 0 && `kart ${formatMoney(r.card)}`, r.credit > 0 && `nisyə ${formatMoney(r.credit)}`].filter(Boolean);
  return `${r.displayNo} yazıldı${parts.length ? `: geri ${parts.join(', ')}` : ''}.`;
}
